module.exports = __webpack_public_path__ + "static/media/haagen.55936c72.jpg";